module.exports = __webpack_public_path__ + "images/f3c9b3c3eb2159c53d3a646107008ac5-favicon-96x96.png";